import CalculatorMultipleSelectInput from '../../../calculatorInputs/CalculatorMultipleSelectInput';
import i18next from 'i18next';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const SetValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  return (
    <CalculatorMultipleSelectInput
      fieldName={`${fieldName}`}
      isRequired
      label={`${
        showLabel ? i18next.t('calculator.dialog.create.label.values') : ''
      }`}
      placeholder={i18next.t(
        `calculator.dialog.create.placeholder.selectValues`
      )}
      options={availableValueOptions}
      uxVariant="criteriaInput"
      variant="standard"
      triggerOnContinue
      disabled={readOnly}
      validate={(value) => {
        if (value.length === 0) {
          setError(`${fieldName}`, {
            type: 'manual',
            message: i18next.t(`calculator.errors.criterionValueEmpty`),
          });
          return false;
        } else {
          clearErrors(`${fieldName}`);
          return true;
        }
      }}
    />
  );
};

export default SetValue;
